class DateInterval {
  constructor(start, end) {
    // two Date instances
    if (start > end) [start, end] = [end, start]; // swap
    this.días = end.getDate() - start.getDate();
    this.meses = end.getMonth() - start.getMonth();
    this.años = end.getFullYear() - start.getFullYear();
    if (this.días < 0) {
      // Add the number of días that are left in the month of the start date
      this.días += new Date(start.getFullYear(), start.getMonth() + 1, 0).getDate();
      this.meses--;
    }
    if (this.meses < 0) {
      this.meses += 12;
      this.años--;
    }
  }

  toString() {
    const age = ['años', 'meses', 'días']
      .map((p) => {
        if (!this[p]) return null;
        let label = p;
        if (this[p] === 1) {
          if (p === 'meses') {
            label = 'mes';
          } else {
            label = p.slice(0, -1);
          }
        }
        return this[p] + ' ' + label;
      })
      .filter(Boolean);

    if (!age.length) return '0 días';

    // Cambia el "años, meses, días" por "años, meses y días"
    const last = age.pop();
    return age.length ? [age.join(', '), last].join(' y ') : last;
  }
}

export function getLove(dateString) {
  let today = new Date();
  today.setHours(0, 0, 0, 0);
  let dob = new Date(dateString);
  dob.setHours(0, 0, 0, 0);
  return new DateInterval(dob, today) + '';
}

export function getLoveEnd(dateString, dateEnd) {
  let end = new Date(dateEnd);
  end.setHours(0, 0, 0, 0);
  let dob = new Date(dateString);
  dob.setHours(0, 0, 0, 0);
  return new DateInterval(dob, end) + '';
}

export function getTimeToDate(dateString) {
  let today = new Date();
  today.setHours(0, 0, 0, 0);
  let dob = new Date(dateString);
  dob.setHours(0, 0, 0, 0);
  return new DateInterval(today, dob) + '';
}
